module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.30150ec5.webp";